import {
  inject,
  Injectable,
} from '@angular/core';
import {UserAclService} from '../../../auth/acl/user-acl/user-acl.service';
import {IframeAuthService} from '../../../auth/iframe-auth/iframe-auth.service';
import {
  createColorSchema,
  IColorSchema,
} from './color-schema.model';
import {PublicEntrypointService} from '../../../auth/public-entrypoint/public-entrypoint.service';

@Injectable({
  providedIn: 'root',
})
export class ColorSchemaService {

  private readonly userAclService: UserAclService = inject(UserAclService);

  private readonly iframeAuthService: IframeAuthService = inject(IframeAuthService);

  private readonly publicEntrypointService: PublicEntrypointService = inject(PublicEntrypointService);

  /**
   * Method: Derive the colour schema from the current login, iframe token or public entry-point page
   */
  public getColorSchema(): IColorSchema {
    return createColorSchema(this.isInsurerScheme());
  }

  /**
   * Method: Check whether the insurer scheme applies to the current token
   */
  private isInsurerScheme(): boolean {
    return this.userAclService.isInsurerRole()
      || this.userAclService.isInsurerRoleType()
      || this.userAclService.isGuestRole()
      || this.iframeAuthService.isInsurerRoleType()
      || this.publicEntrypointService.isPublicEntryPointPage();
  }

}
